<template>
    <div style="padding: 100px 8%;">
        <div class="tab-pane pt-3 active show">
            <div class="row">
              <div class="col-12">
                <h4>保障群組對應保障設定查詢</h4>
                <form class="form">
                  <div class="panel panel-form searchArea">
                    <h4 class="text-green text-center">搜尋條件</h4>
                    <!-- 類型 -->
                    <div class="form-group row">
                      <label class="col-2 text-right">類型：</label>
                      <div class="col-9">
                        <div class="radio radio-inline ml-1">
                          <input type="radio" id="searchTypeCoverage" v-model="searchType" value="code" @change="changeSearchType()">
                          <label for="searchTypeCoverage">保障群組</label>
                        </div>
                        <div class="radio radio-inline">
                          <input type="radio" id="searchTypeDetail" v-model="searchType" value="detail" @change="changeSearchType()">
                          <label for="searchTypeDetail">特殊條件</label>
                        </div>
                      </div>
                    </div>
                    <!-- 代碼/名稱 -->
                    <div class="form-group row">
                      <label class="col-2 text-right">代碼/名稱：</label>
                      <div class="col-9">
                        <v-select
                          v-model="code"
                          :options="options"
                          :reduce="(item) => item.code"
                          label="name"
                          placeholder="請選擇或輸入"
                          ref="selectCode"
                        >
                          <div slot="no-options">沒有資料可供選擇 !</div>
                        </v-select>
                      </div>
                    </div>
                    <div class="text-center">
                      <button class="btn btn-default" @click="doSearch()">搜尋</button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-12 my-5">
                <div v-if="isLoading">
                  <Message
                  class="mt-5 d-flex justify-content-center"
                  loading
                  message="資料讀取中，請稍候..."
                  />
                </div>
                <table class="table datatable" v-else-if="reportList">
                  <thead>
                    <tr>
                      <th
                        style="width:15%"
                        class="text-center sorting"
                        :class="{
                          sorting_asc: showAscClass('report'),
                          sorting_desc: showDescClass('report'),
                        }"
                        @click="changeSort('report')"
                      >API Type/Report Type</th>
                      <th
                        style="width:20%"
                        class="text-center sorting"
                        :class="{
                          sorting_asc: showAscClass('report_name'),
                          sorting_desc: showDescClass('report_name'),
                        }"
                        @click="changeSort('report_name')"
                      >API/報表名稱</th>
                      <th
                        style="width:30%"
                        class="text-center sorting"
                        :class="{
                          sorting_asc: showAscClass('level'),
                          sorting_desc: showDescClass('level'),
                        }"
                        @click="changeSort('level')"
                      >資料階層</th>
                      <th
                        style="width:15%"
                        class="text-center sorting"
                        :class="{
                          sorting_asc: showAscClass(isDetail ? 'code' : 'detail'),
                          sorting_desc: showDescClass(isDetail ? 'code' : 'detail'),
                        }"
                        @click="changeSort(isDetail ? 'code' : 'detail')"
                      >{{ isDetail ? "關聯保障中分類代碼" : "關聯特殊條件編號"}}</th>
                      <th
                        style="width:20%"
                        class="text-center sorting"
                        :class="{
                          sorting_asc: showAscClass(isDetail ? 'code_name' : 'detail_name'),
                          sorting_desc: showDescClass(isDetail ? 'code_name' : 'detail_name'),
                        }"
                        @click="changeSort(isDetail ? 'code_name' : 'detail_name')"
                      >{{ isDetail ? "保障中分類名稱" : "特殊條件名稱"}}</th>
                    </tr>
                  </thead>
                  <tbody v-if="reportList.length">
                    <tr v-for="(report, i) in reportList" :key="`report-data-${i}`">
                      <td :key="`td1-${i}`" class="text-center">{{ report.report }}</td>
                      <td :key="`td2-${i}`" class="text-center">{{ report.report_name }}</td>
                      <td :key="`td3-${i}`">{{ report.level }}</td>
                      <td :key="`td4-${i}`" class="text-center">{{ isDetail ? report.code : report.detail }}</td>
                      <td :key="`td5-${i}`" class="text-center">{{ isDetail ? report.code_name : report.detail_name }}</td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="5">
                        <h4 class="mb-3">查無資料</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import { getOptionsList, searchReport } from "@/service";


export default {
  name: "CoverageReportSearch",
  components: {
    Message,
  },
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      searchType: "code",
      code: "",
      coverageCodeList: [],
      specialConditionList: [],
      reportList: null,
      sortingField: "report",
      sortingType: "asc",
    };
  },
  computed: {
    options() {
      if (this.searchType === "code") return this.coverageCodeList;
      else if (this.searchType === "detail") return this.specialConditionList;
      else return [];
    },
    isDetail() {
      return this.searchType == "detail";
    },
    fields() {
      let result = [
        {
          name: "API Type/Report Type",
          key: "report",
          width: "15%",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          name: "API/報表名稱",
          key: "report_name",
          width: "20%",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          name: "資料階層",
          key: "level",
          width: "30%",
          sortable: true,
          thClass: "text-center",
          tdClass: "",
        },
        {
          name: this.isDetail ? "關聯保障中分類代碼" : "關聯特殊條件編號",
          key: this.isDetail ? "code" : "detail",
          width: "15%",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          name: this.isDetail ? "保障中分類名稱" : "特殊條件名稱",
          key: this.isDetail ? "code_name" : "detail_name",
          width: "20%",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
      ];
      console.log("fields", result)
      return result;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      await getOptionsList(this.$store.state.userInfo.id).then((result) => {
        if (result.header && result.header.status == "200") {
          this.coverageCodeList = result.body.coveragecodelist;
          this.specialConditionList = result.body.specialconditionlist;
        } else {
          this.reportList = [];
        }
        this.isOptionsLoading = false;
      });
    },
    changeSearchType() {
      this.code = "";
      this.reportList = null;
      this.$refs["selectCode"].clearSelection();
    },
    async doSearch() {
      this.isLoading = true;
      let reqData = {
        type: this.searchType,
        code: this.code,
      }
      await searchReport(this.$store.state.userInfo.id, reqData).then((result) => {
        if (result.header && result.header.status == "200") {
          this.reportList = result.data;
        } else {
          this.reportList = [];
        }
        this.isLoading = false;
      });
    },
    showAscClass(field) {
      return field == this.sortingField && "asc" == this.sortingType;
    },
    showDescClass(field) {
      return field == this.sortingField && "desc" == this.sortingType;
    },
    changeSort(field) {
      this.sortingType = this.sortingField == field ? (this.sortingType === 'asc' ? 'desc' : 'asc') : 'asc';
      this.sortingField = field;

      this.reportList.sort((a, b) => {
        let aField = a[this.sortingField].toUpperCase();
        let bField = b[this.sortingField].toUpperCase();
        let comparison = 0;
        if ((this.sortingType === 'asc' && aField > bField)
          || (this.sortingType === 'desc' && aField < bField)) {
          comparison = 1;
        } else if ((this.sortingType === 'asc' && aField < bField)
        || (this.sortingType === 'desc' && aField > bField)) {
          comparison = -1;
        }
        return comparison;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.searchArea {
  border-color: #027A39;
  border-width: 3px;
  background-color: white;
}
</style>